import {registerTileSchema} from '#core/application/schema-registry.js';

import {
    generateErrorNotification,
    generateInfoNotification,
    generateSuccessNotification,
    generateWarningNotification,
} from '#core/application/modules/tiles/notification/index.js';

import BET_NOTIFICATIONS from './bet-notifications.palette-schema.yaml';

registerTileSchema(BET_NOTIFICATIONS);

export function generateBetNotifications(TILE) {
    return {
        container: {
            style: {
                width: '100%',
                boxSizing: 'border-box',
            },
        },
        error: generateErrorNotification(TILE.ERROR_NOTIFICATION),
        success: generateSuccessNotification(TILE.SUCCESS_NOTIFICATION),
        warning: generateWarningNotification(TILE.WARNING_NOTIFICATION),
        info: generateInfoNotification(TILE.INFO_NOTIFICATION),
    };
}
